var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "click-outside",
          rawName: "v-click-outside",
          value: _vm.hideEmoji,
          expression: "hideEmoji"
        }
      ],
      staticClass: "emoji-btn-component"
    },
    [
      _vm.initPicker
        ? _c("picker", {
            directives: [
              {
                name: "show",
                rawName: "v-show",
                value: _vm.showPicker,
                expression: "showPicker"
              }
            ],
            attrs: { data: _vm.$emojiIndex },
            on: { select: _vm.addEmoji }
          })
        : _vm._e(),
      _vm._v(" "),
      _c(
        "button",
        { staticClass: "btn__reset", on: { click: _vm.showEmoji } },
        [_c("i", { staticClass: "icon-smile" })]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }